import React from 'react';

import AttachFile from '@material-ui/icons/AttachFile';
import Timer from '@material-ui/icons/Timer';
import CalendarToday from '@material-ui/icons/CalendarToday';
import Mail from '@material-ui/icons/Mail';

import { timeDiference, getCurrentTime } from '../../../functions/time';

class Message extends React.Component {


    handleClick = () => {
        const { item } = this.props;
        this.props.history.push('/communications/sent/' + item.id);
    };

    render() {
        const { item, intl, param } = this.props;
        return (
            <div className={'padding_4 flex_auto_row hand minHeightRow bg_black_10 ' + (param === item.id.toString() ? 'bg_bluish_25' : '')}
                onClick={this.handleClick}
            >
                <div className="flex_full_row bg_white padding_top_6 padding_left_12 padding_right_6 padding_bottom_6">
                    <div className="flex_full_column">
                        <div className="flex_auto_row margin_bottom_5 align_center">
                            {(item.prioridad === 1) &&
                                <div className="button-message barlow_regular_small c_lipstick border_lipstick">
                                    {intl.formatMessage({ id: 'communication_text_urgent' })}
                                </div>
                            }
                            {item.estado === 0 &&
                                <div className="button-message barlow_regular_small c_slate border_slate">
                                    {intl.formatMessage({ id: 'communication_draft' })}
                                </div>
                            }
                            {(item.estado === 1 || item.estado === 2) &&
                                <div className="flex_auto_row align_center">
                                    <span>
                                        {
                                            item.numLecturas + " de " + item.numDestinatarios
                                        }
                                    </span>
                                </div>
                            }
                            {item.estado === 3 &&
                                <div className="flex_auto_row align_center">
                                    <div className="button-message barlow_regular_small c_pea border_pea">
                                        {intl.formatMessage({ id: 'communication_readed' })}
                                    </div>
                                    <span>
                                        {
                                            item.numLecturas + " de " + item.numDestinatarios
                                        }
                                    </span>
                                </div>
                            }
                            {item.estado === 4 &&
                                <div className="flex_auto_row align_center">
                                    <div className="button-message barlow_regular_small c_bluish border_bluish">
                                        {intl.formatMessage({ id: 'communication_answered' })}
                                    </div>
                                    <span>
                                        {
                                            item.numRespuestas + " de " + item.numDestinatarios
                                        }
                                    </span>
                                </div>
                            }
                            {item.estado === 5 &&
                                <div className="flex_auto_row align_center">
                                    <div className="button-message barlow_regular_small c_disabled border_disabled">
                                        {intl.formatMessage({ id: 'communication_saved' })}
                                    </div>
                                    <span>
                                        {
                                            item.numRespuestas + " de " + item.numDestinatarios
                                        }
                                    </span>
                                </div>
                            }

                        </div>
                        <span className="flex_auto_row barlow_semibold_small c_slate margin_bottom_5">{item.asunto}</span>
                        <div className="flex_auto_row margin_top_12">
                            {item.numAdjuntos > 0 &&
                                <AttachFile className="c_disabled margin_right_6 communications_icon" />
                            }
                            {(item.programada && timeDiference(item.programada, getCurrentTime()) !== '00 s') &&
                                <div className="flex_auto_row margin_right_6 align_center">
                                    <CalendarToday className="c_disabled margin_right_6 communications_icon" />
                                    <span className="flex_auto_row barlow_regular_small c_cool_grey margin_right_2 nowrap">
                                        {intl.formatMessage({
                                            id: 'communication_remaining_time_sent',
                                        })}
                                    </span>
                                    <span className="flex_auto_row barlow_regular_small c_cool_grey margin_right_24 nowrap">
                                        {item.programada.substring(0, item.programada.length - 3)}
                                    </span>
                                </div>
                            }
                            {(item.limite && timeDiference(item.limite, getCurrentTime()) !== '00 s') &&
                                <div className="flex_auto_row margin_right_6 align_center">
                                    <Timer className="c_disabled margin_right_2 communications_icon" />
                                    <span className="flex_auto_row barlow_regular_small c_cool_grey margin_right_2 nowrap">{intl.formatMessage({ id: 'communication_remaining_time' })}</span>
                                    <span className="flex_auto_row barlow_regular_small c_cool_grey margin_right_2 nowrap">{item.limite.substring(0, item.limite.length - 3)}</span>
                                </div>
                            }
                            {(item.limite && timeDiference(item.limite, getCurrentTime()) === '00 s') &&
                                <div className="button-message barlow_regular_small c_lipstick border_lipstick margin_left_6">
                                    {intl.formatMessage({ id: 'communication_expired' })}
                                </div>
                            }
                            {item.numComentarios > 0 &&
                                <div className={"bubbly " + (item.comentariosPendientes ? ' bubbly-active' : '')}>{item.numComentarios}</div>
                            }
                            {item.numRespuestas > 0 &&
                                <div className="flex_auto_row margin_right_6">
                                    <Mail className={item.respuestasPendientes ? 'c_bluish' : 'c_disabled'} />
                                    <span className="flex_auto_row barlow_regular_small c_cool_grey margin_right_2">{item.numRespuestas}</span>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="flex_auto_column center padding_left_6">
                        <p className="barlow_regular_subtitle c_cool_grey">{item.enviada}</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default Message;



// WEBPACK FOOTER //
// ./src/components/complex/communications/Communications.js